import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Aluno.module.css"
import Alerta from "../../components/alerta/Alerta";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import { Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import AlunoApi from "../../services/AlunoApi";
import Paginacao from "../../components/paginacao/Paginacao";
import UsuarioApi from "../../services/UsuarioApi";
import { IoDocumentSharp } from "react-icons/io5";
import Loader from "../../components/loader/Loader";
import InputMask from "react-input-mask";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";


function Aluno() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Modais para editar e excluir
    const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    //Para rodar a tabela, paginação e filtro
    const [usuarios, setUsuarios] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [nomeFiltro, setNomeFiltro] = useState("");
    const [emailFiltro, setEmailFiltro] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);

    //Para modal de editar
    const [nomeNovo, setNomeNovo] = useState("");
    const [nomeContatoNovo, setNomeContatoNovo] = useState("");
    const [cpfNovo, setCpfNovo] = useState(null)
    const [rgNovo, setRgNovo] = useState(null)
    const [statusNovo, setStatusNovo] = useState(null)
    const [dataDeNascimentoNovo, setDataDeNascimentoNovo] = useState(null);
    const [alunoId, setAlunoId] = useState(null);
    const [statusUsuarios, setStatusUsuarios] = useState([]);

    const [loading, setLoading] = useState(false);

    //Função para filtro de busca
    async function BuscarUsuarios() {
        setNome(nomeFiltro);
        setEmail(emailFiltro);
        setPaginaAtual(1);
        await CarregarUsuarios(1, nomeFiltro, emailFiltro);
    }

    //Função para resetar  filtro de busca
    async function ResetarUsuarios() {
        setNome("");
        setEmail("");
        setNomeFiltro("");
        setEmailFiltro("");
        setPaginaAtual(1);
        await CarregarUsuarios(1, "", "");
    }

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
        await CarregarUsuarios(paginaNova, nomeFiltro, emailFiltro);
    }


    //Função para abrir o modal de editar
    const AbrirModalEditar = async (usuario) => {
        const usuarioEditar = await AlunoApi.ObterAlunoPorPessoaId(usuario.pessoaID);

        setUsuarioSelecionado(usuario);
        setNomeNovo(usuarioEditar.nomeCompleto);
        setNomeContatoNovo(usuarioEditar.nomeContato);
        setCpfNovo(usuarioEditar.cpf);
        setRgNovo(usuarioEditar.rg);
        setStatusNovo(usuario.status);
        setAlunoId(usuario.pessoaID);
        setDataDeNascimentoNovo(usuarioEditar.dataDeNascimento);
        setMostrarModalEditar(true);
    };


    //Função para abrir o modal de deletar
    const AbrirModalDeletar = (usuario) => {
        setUsuarioSelecionado(usuario);
        setMostrarModalDeletar(true);
    };

    //Função para editar Usuarios
    const BotaoEditar = async () => {
        try {
            setLoading(true);
            await AlunoApi.EditarAlunoAsync(usuarioSelecionado.pessoaID, nomeNovo, nomeContatoNovo, cpfNovo, rgNovo, dataDeNascimentoNovo, statusNovo);
            CarregarUsuarios();
            setMensagemAlerta(`Usuário atualizado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao atualizar usuário: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    };

    //Função para deletar usuarios
    const BotaoDeletar = async () => {
        try {
            setLoading(true);
            await AlunoApi.DeletarAlunoAsync(usuarioSelecionado.pessoaID);
            setUsuarios(usuarios.filter((u) => u.pessoaID !== usuarioSelecionado.pessoaID));
            setMensagemAlerta(`Usuário deletado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao deletar usuário: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    };

    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalDeletar(false);
        setMostrarModalEditar(false);
        setUsuarioSelecionado(null);
    };

    //Função para carregar os usuarios
    async function CarregarUsuarios(paginaAtual, nome, email) {

        try {

            const listaUsuarios = await AlunoApi.ListarAlunosAsync(
                paginaAtual,
                nome, 
                email
            );
            setQuantidadeItens(listaUsuarios.quantidadeRegistros);
            setUsuarios(listaUsuarios.registros);

        } catch (error) {

            console.error("Erro ao carregar usuários:", error.response.data);
        } finally {

        }
    }

    //Função para o modal de Editar
    async function BuscarStatusUsuarios() {
        try {
            const status = await UsuarioApi.ListarStatusUsuarioAsync();
            setStatusUsuarios(status);
        } catch (error) {
            console.error("Erro ao buscar status do usuário:", error.response.data);
        }
    }

    const totalPaginas = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    useEffect(() => {
        CarregarUsuarios(1, nomeFiltro, emailFiltro)
        BuscarStatusUsuarios()
    }, []);

    useEffect(() => {
        CarregarUsuarios(paginaAtual, nome, email);
    }, [paginaAtual, nomeFiltro, emailFiltro]);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>

                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    {/* Cabeçalho da pagina */}
                    <div className={style.container_cabecalho}>
                        <h4>Alunos</h4>
                    </div>

                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>
                        <InputBuscar
                            type="text"
                            id="hidenNome"
                            placeholder="Nome"
                            name="nome"
                            maxLength={30}
                            value={nomeFiltro}
                            onChange={(e) => setNomeFiltro(e.target.value)}
                        />

                        <InputBuscar
                            type="text"
                            id="hidenEmail"
                            placeholder="Email"
                            name="email"
                            maxLength={50}
                            value={emailFiltro}
                            onChange={(e) => setEmailFiltro(e.target.value)}
                        />
                        <div className={style.container_filtro2}>
                            <Button onClick={BuscarUsuarios} id={style.botao_buscar}><MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarUsuarios} id={style.botao_resetar}><MdClose /> Limpar
                            </Button>

                        </div>

                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Último login</th>
                                        <th>Status</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usuarios.map((usuario) => (
                                        <tr className={style.tabela_corpo} key={usuario.pessoaID}>
                                            <td title={usuario.nomeCompleto}>{usuario.nomeCompleto}</td>
                                            <td title={usuario.email}>{usuario.email}</td>
                                            <td title={usuario.dataUltimoLogin}>{new Date(usuario.dataUltimoLogin).toLocaleDateString('pt-BR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}{' '}
                                                {new Date(usuario.dataUltimoLogin).toLocaleTimeString('pt-BR', {
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                })}
                                            </td>
                                            <td title={statusUsuarios.find(s => s.id === usuario.status)?.nome}>{statusUsuarios.find(s => s.id === usuario.status)?.nome}</td>
                                            <td className={style.coluna_acoes}>

                                                <Link
                                                    to="/backoffice/documento"
                                                    state={{
                                                        pessoaID: usuario.pessoaID,
                                                        nomeCompleto: usuario.nomeCompleto
                                                    }}
                                                    className={style.botao_documento}
                                                >
                                                    <IoDocumentSharp title="Documento" />
                                                </Link>


                                                <Link
                                                    onClick={() => AbrirModalEditar(usuario)}
                                                    className={style.botao_editar}
                                                >
                                                    <MdEdit
                                                        title="Editar" />
                                                </Link>
                                                <Link
                                                    onClick={() => AbrirModalDeletar(usuario)}
                                                    className={style.botao_deletar}
                                                >
                                                    <MdDelete
                                                        title="Deletar" />
                                                </Link>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Controle de Paginação */}
                        <Paginacao
                            id={style.configuracao_paginacao}
                            paginaAtual={paginaAtual}
                            totalPages={totalPaginas}
                            onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                        />
                    </div>
                    {/* Modal de confirmação */}
                    <Modal show={mostrarModalDeletar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            Tem certeza que deseja deletar o usuário{" "}
                            {usuarioSelecionado?.nomeCompleto}?
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="danger" onClick={BotaoDeletar}>
                                Deletar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal de confirmação */}
                    <Modal show={mostrarModalEditar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Editar Aluno</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form.Group controlId="nome" className="mb-3">
                                <Form.Label>Nome Completo</Form.Label>
                                <InputBuscar
                                    maxLength={100}
                                    type="text"
                                    placeholder="Nome completo"
                                    value={nomeNovo}
                                    onChange={(e) => setNomeNovo(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="cpf" className="mb-3">
                                <Form.Label>CPF</Form.Label>
                                <InputMask

                                    mask="999.999.999-99"
                                    value={cpfNovo}
                                    disabled
                                    onChange={(e) => setCpfNovo(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <InputBuscar
                                            id={style.desabilitar}
                                            {...inputProps}
                                            type="text"
                                            placeholder="___.___.___-__"
                                            maxLength={14} // com máscara, 14 caracteres com pontos e traço
                                        />
                                    )}
                                </InputMask>
                            </Form.Group>

                            <Form.Group controlId="rg" className="mb-3">
                                <Form.Label>RG</Form.Label>
                                <InputMask
                                    mask="99.999.999"
                                    value={rgNovo}
                                    disabled
                                    onChange={(e) => setRgNovo(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <Form.Control
                                            id={style.desabilitar}
                                            {...inputProps}
                                            type="text"
                                            placeholder="RG"
                                        />
                                    )}
                                </InputMask>
                            </Form.Group>

                            <Form.Group controlId="dataNascimento" className="mb-3">
                                <Form.Label>Data de Nascimento</Form.Label>
                                <InputBuscar
                                    type="date"
                                    value={dataDeNascimentoNovo}
                                    onChange={(e) => setDataDeNascimentoNovo(e.target.value)}
                                    min="1900-01-01"
                                    max="2099-12-31"
                                />
                            </Form.Group>

                            <Form.Group controlId="formStatusUsuario" className="mb-3">
                                <Form.Label>Status do Usuário</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="statusUsuario"
                                    value={statusNovo}
                                    onChange={(e) => setStatusNovo(e.target.value)}
                                    required
                                >
                                    {statusUsuarios.map((statusUsuario) => (
                                        <option key={statusUsuario.id} value={statusUsuario.id}>
                                            {statusUsuario.nome}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={BotaoEditar}>
                                Atualizar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Topbar >
        </Sidebar>
    );
}

export default Aluno;